import { f as fetchCartData, s as sendAddToCart } from "./cart-DXzKAPAO.js";
class FreeGift extends HTMLElement {
  constructor() {
    super();
    this.freeGiftProduct = null;
    this.threshold = null;
    this.thresholdPrice = null;
    this.addToCartButton = null;
    this.freeGiftText = null;
    this.freeGiftTitleThreshold = null;
    this.freeGiftTitle = null;
    this.cartValue = null;
    this.cartData = { items: void 0 };
  }
  connectedCallback() {
    this.initializeElements();
    this.getCartValue();
    document.addEventListener("cart:updated", this.getCartValue.bind(this));
  }
  initializeElements() {
    this.addToCartButton = this.querySelector("[data-add-to-cart]");
    this.freeGiftText = this.querySelector(".free-gift__text");
    this.freeGiftTitleThreshold = this.querySelector(
      ".free-gift__title-threshold"
    );
    this.freeGiftTitle = this.querySelector(".free-gift__title");
  }
  async getFreeGiftProduct() {
    this.freeGiftProduct = this.getAttribute("free-gift-product");
  }
  async getThreshold() {
    this.thresholdPrice = parseInt(this.getAttribute("data-threshold") ?? "0") * 100;
  }
  async getCartValue() {
    const cartData = await fetchCartData();
    this.cartData = cartData;
    this.cartValue = cartData.items_subtotal_price || null;
    await this.getFreeGiftProduct();
    await this.getThreshold();
    this.updateUI();
  }
  updateUI() {
    this.setButton();
    this.setText();
    this.handleAddToCart();
  }
  setText() {
    var _a;
    const item = (_a = this.cartData.items) == null ? void 0 : _a.find(
      (item2) => item2.id == this.freeGiftProduct
    );
    if (item) {
      this.toggleDisplay(this, "none");
    } else if (this.cartValue !== null && this.thresholdPrice !== null && Number(this.cartValue) >= this.thresholdPrice && !item) {
      this.toggleDisplay(this.freeGiftText, "none");
      this.toggleDisplay(this.freeGiftTitleThreshold, "none");
      this.toggleDisplay(this.freeGiftTitle, "block");
    } else {
      this.toggleDisplay(this.freeGiftText, "block");
      this.toggleDisplay(this.freeGiftTitleThreshold, "block");
      this.toggleDisplay(this.freeGiftTitle, "none");
    }
  }
  setButton() {
    var _a;
    const item = (_a = this.cartData.items) == null ? void 0 : _a.find(
      (item2) => item2.id == this.freeGiftProduct
    );
    this.style.display = item ? "none" : "block";
    if (!item && this.thresholdPrice !== null && this.cartValue !== null && Number(this.cartValue) >= this.thresholdPrice) {
      this.toggleDisplay(this.addToCartButton, "block");
    } else {
      this.toggleDisplay(this.addToCartButton, "none");
    }
  }
  toggleDisplay(element, displayValue) {
    if (element) {
      element.style.display = displayValue;
    }
  }
  handleAddToCart() {
    if (!this.addToCartButton)
      return;
    this.addToCartButton.addEventListener("click", async () => {
      const freeGiftProduct = {
        id: this.freeGiftProduct || "",
        quantity: 1,
        properties: { free_gift: "true" },
        selling_plan: ""
      };
      await sendAddToCart([freeGiftProduct]);
    });
  }
}
customElements.define("uwp-free-gift", FreeGift);
